import React, { ReactNode } from "react";
import { Flex, Stack, Text } from "flicket-ui";

type SubHeaderProps = {
  children: ReactNode;
};

export const MobileSubHeader = ({ children }: SubHeaderProps) => (
  <Flex
    d={{ _: "flex", md: "none" }}
    justifyContent="space-between"
    position="relative"
    w="100vw"
    p={2}
    ml={-2 as any}
    mt="6/4"
    bg="white"
  >
    {/* Making this element a flex container so that all content is centered */}
    <Text variant="header.M" as={Stack} gap={1} alignItems="center">
      {children}
    </Text>
  </Flex>
);
